<p-toast></p-toast>

<div class="warehousing-page">

  <app-warehousing-page-header activeSection="overview" title="Warehousing Control Center" subtitle="Operational overview for stock, dispatch, destruction, refurbishment, and storage billing.">
    <div actions>
      <p-button label="Refresh" icon="pi pi-refresh" severity="secondary" [outlined]="true" [loading]="loading()" (onClick)="loadAll()"></p-button>
    </div>
  </app-warehousing-page-header>

  <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

  <div class="overview-grid">
    <section class="overview-panel">
      <div class="section-header">
        <div>
          <h2>Recent On Hand Stock</h2>
          <p>{{ summaries().length }} stock groups</p>
        </div>
        <p-button label="View On Hand Stock" size="small" [outlined]="true" routerLink="/warehousing/stock"></p-button>
      </div>
      <p-table [value]="summaries()" [rows]="6" styleClass="p-datatable-sm overview-data-table" [tableStyle]="{ 'min-width': '42rem' }">
        <ng-template pTemplate="header"><tr><th>Item</th><th>Status</th><th class="text-right">Available</th><th class="text-right">SQM</th></tr></ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>
              <div class="stack-cell">
                <span class="cell-title">{{ row.itemName }}</span>
                <span *ngIf="itemSizeLabel(row)" class="cell-meta"><i class="pi pi-expand"></i> {{ itemSizeLabel(row) }}</span>
              </div>
            </td>
            <td><p-tag [value]="row.status" [severity]="statusSeverity(row.status)"></p-tag></td>
            <td class="text-right">{{ row.availableQuantity | number:'1.0-2' }}</td>
            <td class="text-right">{{ row.occupiedSqm | number:'1.2-4' }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr><td colspan="4"><div class="empty-state"><i class="pi pi-search"></i><strong>No stock found</strong><span>No stock summary records.</span></div></td></tr>
        </ng-template>
      </p-table>
    </section>

    <section class="overview-panel">
      <div class="section-header">
        <div>
          <h2>Destruction Queue</h2>
          <p>{{ destructions().length }} destruction records</p>
        </div>
        <p-button label="Open Destructions" size="small" [outlined]="true" routerLink="/warehousing/destruction"></p-button>
      </div>
      <p-table [value]="destructions()" [rows]="6" styleClass="p-datatable-sm overview-data-table" [tableStyle]="{ 'min-width': '42rem' }">
        <ng-template pTemplate="header"><tr><th>Destruction</th><th>Reason</th><th>Status</th><th class="text-right">Qty</th></tr></ng-template>
        <ng-template pTemplate="body" let-destruction>
          <tr>
            <td>{{ destruction.destructionNumber || ('Draft #' + destruction.id) }}</td>
            <td>{{ destruction.reason || '-' }}</td>
            <td><p-tag [value]="destruction.status" [severity]="statusSeverity(destruction.status)"></p-tag></td>
            <td class="text-right">{{ destruction.quantityDestroyed | number:'1.0-2' }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr><td colspan="4"><div class="empty-state"><i class="pi pi-search"></i><strong>No destructions found</strong><span>No destruction records.</span></div></td></tr>
        </ng-template>
      </p-table>
    </section>

    <section class="overview-panel">
      <div class="section-header">
        <div>
          <h2>Billing Drafts</h2>
          <p>{{ billingDrafts().length }} draft records</p>
        </div>
        <p-button label="Open Drafts" size="small" [outlined]="true" routerLink="/warehousing/billing-drafts"></p-button>
      </div>
      <p-table [value]="billingDrafts()" [rows]="6" styleClass="p-datatable-sm overview-data-table" [tableStyle]="{ 'min-width': '42rem' }">
        <ng-template pTemplate="header"><tr><th>Draft</th><th>Client</th><th>Status</th><th class="text-right">Amount</th></tr></ng-template>
        <ng-template pTemplate="body" let-draft>
          <tr>
            <td>{{ draft.draftNumber }}</td>
            <td>{{ clientName(draft.crmClientId) }}</td>
            <td><p-tag [value]="draft.status" [severity]="statusSeverity(draft.status)"></p-tag></td>
            <td class="text-right">{{ draft.totalEditedAmount | number:'1.2-2' }} {{ draft.currency }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr><td colspan="4"><div class="empty-state"><i class="pi pi-search"></i><strong>No drafts found</strong><span>No billing draft records.</span></div></td></tr>
        </ng-template>
      </p-table>
    </section>
  </div>
</div>
